<template>
  <div v-show="isActive" class="popup-wrap transfer" :class="{ active: isActive }">
    <div class="popup-box">
      <a class="popup-close" @click="hideTransferModal" />

      <div class="content">
        <h3>{{ $t('Bao.transfer_to_main') }}</h3>
        <hr>
        <div class="transfer-frame">
          <div>{{ $t('Bao.trading_balance') }}</div>
          <div class="text-align-R">
            <b class="balance">{{ $store.state.brand.currency }}{{ tradingBalance }}</b>
          </div>
        </div>
        <form @submit.prevent="submitForm">
          <div class="label-frame">
            <label class="title" for="amount">{{ $t('Bao.transfer_amount') }}</label>
            <input id="amount" v-model="amount" class="input" type="text">
            <div v-if="!isAmountValid" class="form-message">
              <i><img :src="$getThemeImagePath('icon-alert.png')" alt=""></i>
              <span>  {{ $t('Bao.transfer_error') }}</span>
            </div>
            <p class="tips-text text-align-R">
              {{ $t('Bao.withdraw_multiply') }}
            </p>
            <button type="submit" class="btn btn-style-primary text-center">
              {{ $t('Bao.transfer') }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { commissionToMain } from '@/api/payment'
import { showNotice } from '@/utils/tool'

export default {
  name: 'TransferModal',
  props: {
    isActive: Boolean,
    tradingBalance: {
      type: String,
      default: () => ('')
    }
  },
  data() {
    return {
      amount: ''
    }
  },
  computed: {
    isAmountValid() {
      const number = parseFloat(this.amount)
      return Number.isInteger(number) && number > 0
    }
  },
  methods: {
    hideTransferModal() {
      this.$emit('hideTransferModal')
    },
    submitForm() {
      if (this.isAmountValid) {
        commissionToMain({ amount: this.amount }).then((result) => {
          this.amount = ''
          showNotice(this.$t('Bao.transfer_success'))
          this.$emit('hideTransferModal')
        }).catch((err) => {
          console.log(err)
        })
      }
    }
  }
}
</script>

<style scoped>
.tips-text {
  font-size: small;
}
</style>
